/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { pageTypes } from '@/constants/page';
import { useCategoryByModel } from '../../../api/getCategoryModels';
import { usePageType } from '../../../api/getPageType';
import { ShopByModelList } from '@/features/shopByModel';
import { useRouter } from 'next/router';

export const CMSSmmy = () => {
  const router = useRouter();
  const { data: pageTypeData, isSuccess } = usePageType();
  const { data: categoryByModelData } = useCategoryByModel({
    enabled:
      Boolean(pageTypeData?.make) &&
      !Boolean(pageTypeData?.model) &&
      pageTypeData?.pageType === pageTypes.CategoryGrouping &&
      isSuccess,
    seoUrl: router.asPath,
  });

  const devices = {
    desktop: true,
    tablet: true,
    mobile: true,
  };
  const shopByMMYList = categoryByModelData?.shopByMMYList ?? [];
  if (shopByMMYList.length) {
    return (
      <ShopByModelList
        data={{
          shopByMMYList,
          title: categoryByModelData?.title ?? '',
          canonicalPath: categoryByModelData?.canonicalPath,
          taxonomyPath: categoryByModelData?.taxonomyPath,
          pageType: categoryByModelData?.pageType,
          ...devices,
        }}
      />
    );
  }
  return null;
};
